<template>
    <b-modal
            :id="modalId"
            :visible="show"
            @hidden="hideEvents"
            title="Add New Contact"
            scrollable
    >
        <vue-element-loading :active="loading" :is-full-screen="false"/>
        <r-form
                ref="form"
                v-model="form"
                :validators="validators"
                :disabled="false"
                :show-header="false"
                :show-footer="false"
                @valid="setValid"
        >
        </r-form>
        <template slot="modal-footer">
            <b-button
                    @click="hideModal"
                    variant="outline-secondary">
                Cancel
                <font-awesome-icon
                        :icon="['far', 'times']">
                </font-awesome-icon>
            </b-button>
            <b-button
                :disabled="loading"
                @click="onClickAddNewContact"
                class="btn-arrow"
                variant="primary"
            >
                Add new contact
                <font-awesome-icon
                        :icon="['far', 'arrow-right']">
                </font-awesome-icon>
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import CaretIcon from '@/components/Form/CaretIcon';
import ModalMixin from '@/components/Modal/ModalMixin';
import FormValidate from '@/services/Mixins/FormValidate';
import RForm from '@/components/Form/RiskhubForm';
import PropertyContact from '@/services/Property/PropertyContact';
import { forEach } from 'lodash';
import { form as PropertyContactForm, validators as PropertyContactFormValidators } from '@/services/Property/PropertyContactForm';
import Property from '@/services/Property/Property';
import ErrorMixin from '@/components/Notifications/ErrorMixin';

export default {
  name: 'Add-Contact-Modal',
  components: {
    CaretIcon,
    RForm,
  },
  props: {
    propertyId: {
      required: true,
    },
  },
  mixins: [ModalMixin, FormValidate, ErrorMixin],
  data() {
    return {
      modalId: 'addContactModal',
      loading: false,
      options: [],
      valid: false,
      form: PropertyContactForm(),
      validators: PropertyContactFormValidators,
    };
  },
  computed: {
    disabled() {
      return false;
    },
  },
  created() {
    delete this.form.propertyContactId;
  },
  methods: {
    onClickAddNewContact() {
      this.addContact();
    },
    async addContact() {
      if (!this.$refs.form.isValidated()) {
        return;
      }

      this.loading = true;

      const params = {};

      forEach(this.form, (object, key) => {
        if (object.value.length > 0) {
          params[key] = object.value;
        }
      });

      try {
        const { data } = await PropertyContact.add(params);
        await Property.update(this.propertyId, data.data);

        const title = 'New contact added';
        const text = `Contact # ${data.data.propertyContactId} successfully added`;
        const type = 'success';

        this.$notify({
          duration: 7000,
          title,
          text,
          type,
        });

        this.hideModal();

        this.$emit('newContactAdded', data.data.propertyContactId);
      } catch (e) {
        this.showValidationError(e);
      } finally {
        this.loading = false;
      }
    },
    setValid(valid) {
      this.valid = valid;
    },
  },
};
</script>

<style lang="scss">
.modal-body-sm .modal .modal-body {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}
</style>
